import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import { getShipnameList } from "./HelpersAPI";
let user = JSON.parse(localStorage.getItem("currentUser"));

export const getVisitorSearchList = (item, pgnumber, shipMail, id) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.SearchVisitors}?ShipId=${id ?? 0}&ShipName=${item.shipName}&mail=${emailShip ?? ""}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&FromDate=${item.fromDate}&ToDate=${item.toDate}&ExcludeRefuse=${item.ExcludeRefuse}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getVisitorListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getVisitorListFailure",
          error: "ERROR",
        });
      });
  };
};

export const ExportExcelVisitor = (item, pgnumber) => {
  let url = `${API.ExportVisitor}?ShipId=${item.ShipId ?? 0}&ShipName=${item.shipName}&mail=${user.email ?? ""}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&FromDate=${item.fromDate}&ToDate=${item.toDate}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = '';
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, "Reports");
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};
export const getVisitorDetails = (visitorId) => {
  let url = `${API.GetVisitorDetails}?VisitorId=${visitorId}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getVisitorDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getVisitorDetailsFailure",
          error: "ERROR"
        })
      })
  }
}

export const addNewVisitor = (data) => {
  let url = `${API.PostVisitor}`;
  return dispatch => {
    axios.post(url, data)
      .then((response) => {
        dispatch({
          type: "postAddVisitorSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postAddVisitorFailure",
          error: "ERROR"
        })
      })
  }
}

export const getVisitorPhoto = (id) => {
  let url = `${API.VisitorPhoto}?reportId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getVisitorPhotoSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "getVisitorPhotoFailure",
          error: "ERROR"
        })
      })
  }
}
export const getCrewIdList = () => {
  let url = `${API.CrewIdsList}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {

        dispatch({
          type: "getCrewIdListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCrewIdListFailure",
          error: "ERROR",
        });
      });
  };
};

export const getVisitorSearchListDidmount = (item, pgnumber, shipMail, id) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.SearchVisitors}?ShipId=${id ?? 0}&ShipName=${item.shipName}&mail=${emailShip ?? ""}&isPass=${item.isPass ?? false}&showAllResult=${item.showAllResult ?? true}&FromDate=${item.fromDate}&ToDate=${item.toDate}&ExcludeRefuse=${item.ExcludeRefuse}&PageNumber=${pgnumber ?? 1}&PageSize=${item.PageSize ?? 25}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getVisitorListSuccess",
          data: response.data,
        });
        dispatch(getShipnameList());
      })
      .catch((error) => {
        dispatch({
          type: "getVisitorListFailure",
          error: "ERROR",
        });
      });
  };
};